exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-meta-selector {\n  margin: 16px 0; }\n\n.full-width {\n  width: 100%; }\n\n.parent-option {\n  font-weight: bold;\n  color: #666;\n  background-color: #f5f5f5;\n  cursor: default; }\n\n.child-option {\n  padding-left: 35px; }\n\n.selection-info {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #666; }\n\n.selection-count {\n  font-weight: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/user-meta-multiselect/user-meta-multiselect.component.scss
// module id = ../../../../../src/app/shared/components/user-meta-multiselect/user-meta-multiselect.component.scss
// module chunks = main